import React from 'react'
import ReactGA from 'react-ga'

import { Link } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import ReactQuill, { Quill, Mixin, Toolbar } from 'react-quill'

// import { Spin, Alert } from 'antd'

import ajax from '../ControlPanel/utils/ajax'
import globalConfig from '../ControlPanel/config'

import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import Card, { CardActions, CardContent } from 'material-ui/Card'
import Button from 'material-ui/Button'
import Typography from 'material-ui/Typography'
import { CircularProgress } from 'material-ui/Progress'
import Styles from '../../styles/Styles'

import 'react-quill/dist/quill.bubble.css'
// import 'react-quill/dist/quill.snow.css'

import classNames from 'classnames'

import '../../styles/Quill.scss'


/*
 * Simple editor component that takes placeholder text as a prop
 */
class QuillReadOnlyBlock extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            theme: 'bubble',
            // theme: 'snow',
        }
    }

    render() {
        const { classes, text } = this.props
        // bounds="QuillReadOnlyBlock"
        return (
            <ReactQuill
                theme={this.state.theme}
                value={text}
                readOnly={true}
                modules={QuillReadOnlyBlock.modules}
                formats={QuillReadOnlyBlock.formats}
                placeholder=""
                style={{ margin: '0' }}
            />
        )
    }
}

QuillReadOnlyBlock.formats = [
    'header', 'font', 'size', 'background', 'color', 'code-block',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video',
    'align', 'direction', 'script',
    'formula',
]

QuillReadOnlyBlock.modules = {
    formula: true,
    toolbar: false,
    clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: true,
    },
}

/*
 * PropType validation
 */
QuillReadOnlyBlock.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(Styles)(QuillReadOnlyBlock)
